import { EMediaType } from '../../components/NewbuildingTiledCarousel/FullscreenGallery';
import { IMediaItem, IPhotoSchema } from '../../types/newbuildingTiledCarousel';

export const mapOfferDataToNewbuildingGallery = (offerPhotos: IPhotoSchema[]): IMediaItem[] => {
  const photos = offerPhotos
    .filter(item => !!item.fullUrl && !!item.thumbnailUrl)
    .map((item, i) => ({
      alt: '',
      fullUrl: item.fullUrl as string,
      id: item.id || i,
      isPrimaryImage: item.isDefault,
      mediaType: EMediaType.Image,
      thumbnailUrl: item.thumbnailUrl as string,
      isLayout: !!item.isLayout,
      isFloorPlan: !!item.isFloorPlan,
      polygonPath: item.polygonPath || null,
    }));

  return photos;
};
